var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAttendance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_997_8282)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_997_8282",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H20V20H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_997_8282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.70996 15.6699V16.6465C6.70996 17.4016 7.32207 18.0137 8.07715 18.0137C8.83223 18.0137 9.44434 17.4016 9.44434 16.6465V15.8369",
    stroke: "#757575",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97559 16.475V16.6465C3.97559 17.4016 4.5877 18.0137 5.34277 18.0137C6.09785 18.0137 6.70996 17.4016 6.70996 16.6465V15.6699",
    stroke: "#757575",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1242 5.85145L15.4832 8.63859H16.9926V15.9937C15.8838 16.5482 14.5916 16.8418 13.3505 16.8418C12.1093 16.8418 10.8671 16.5482 9.75816 15.9937L9.11008 15.67H4.45508",
    stroke: "#757575",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64888 5.44987L7.29857 5.29417C6.78103 5.06413 6.17955 5.13218 5.72646 5.47198L4.06756 6.71616C3.58482 7.07823 3.18373 7.53792 2.89045 8.0653L0.7599 11.8963C0.394158 12.554 0.623534 13.3835 1.27525 13.7597C1.87107 14.1037 2.61217 13.9537 3.03513 13.4406",
    stroke: "#757575",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98328 1.40617L9.00684 3.0977L11.0365 4.26953L12.0132 2.57801C12.2289 2.2043 12.1009 1.72648 11.7271 1.51074L11.0505 1.12016C10.6768 0.904453 10.199 1.0325 9.98328 1.40617Z",
    stroke: "#757575",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03328 12.9353L11.0367 4.26977L9.00684 3.09793L1.97535 15.2761L1.15137 18.9844L4.00504 16.448L4.45445 15.6697",
    stroke: "#757575",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4141 17.0312H16.9922V7.65625H19.4141V17.0312Z",
    stroke: "#757575",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7418 11.7637L9.1793 12.9355H4.16992C3.41484 12.9355 2.80273 13.5477 2.80273 14.3027C2.80273 15.0579 3.41484 15.6699 4.16992 15.6699H9.1093",
    stroke: "#757575",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_997_8282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAttendance);
export default __webpack_public_path__ + "static/media/ic-attendance.147fe1bfb093d7d9fa7ad08a69736a33.svg";
export { ForwardRef as ReactComponent };